import { authMiddleware } from "@shared";

import { Configuration } from "./api-client";
import { errorMiddleware } from "./middleware/errorMiddleware";

export const apiConfiguration = new Configuration({
  basePath: "",
  middleware: [authMiddleware, errorMiddleware],
  credentials: "include",
});
